var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"headers":_vm.headers,"data":_vm.societies,"items-per-page":10,"buttons":_vm.buttons,"tableActions":_vm.tableActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }